import { render, staticRenderFns } from "./Tag-In-Out-History.vue?vue&type=template&id=6f233dd2&"
import script from "./Tag-In-Out-History.vue?vue&type=script&lang=ts&"
export * from "./Tag-In-Out-History.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports